import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

import zoomInIcon from 'appSrc/assets/img/cropper/zoom-in.png';
import zoomOutIcon from 'appSrc/assets/img/cropper/zoom-out.png';

class PlusMinusControls extends PureComponent {
    render() {
        return (
            <div className={ style.plusMinusControls }>
                <span className={ style.text }>Click to Zoom:</span>
                <span className={ style.control } onClick={ this.props.zoomIn }><img src={ zoomInIcon } alt='zoom in'/></span>
                <span className={ style.control } onClick={ this.props.zoomOut }><img src={ zoomOutIcon } alt='zoom in'/></span>
            </div>
        );
    }
}
PlusMinusControls.propTypes = {
    zoomIn: PropTypes.func.isRequired,
    zoomOut: PropTypes.func.isRequired,
};

export default PlusMinusControls;
